import { render, staticRenderFns } from "./AdRankBrandView.vue?vue&type=template&id=5ada976b&scoped=true"
import script from "./AdRankBrandView.vue?vue&type=script&lang=js"
export * from "./AdRankBrandView.vue?vue&type=script&lang=js"
import style0 from "./AdRankBrandView.vue?vue&type=style&index=0&id=5ada976b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ada976b",
  null
  
)

export default component.exports